module.exports = __webpack_public_path__ + "img/icm-webinar.043518b9.png";